import React from 'react';
import { FMDropdown } from '@own/fds-react';
import { Option } from '@own/fds-react/dist/types/fm-dropdown.types';
import { ImgSpcFieldLabelsContentFragment } from '../../../../models/img-service-price-calculator/img-service-price-calculator';

export interface ServiceIntervalDropdownProps {
    service: any;
    serviceInterval: any;
    handleIntervalDropdown: (event: any) => void;
    fieldsLabel?: ImgSpcFieldLabelsContentFragment;
    disabled?: boolean;
}

const ServiceIntervalDropdown = ({
    service,
    serviceInterval,
    handleIntervalDropdown,
    fieldsLabel,
    disabled = false,
}: ServiceIntervalDropdownProps) => {
    return (
        <div className="img-spc-service-interval-dropdown">
            <FMDropdown
                header={fieldsLabel?.selectYourServiceIntervalLabel}
                value={serviceInterval}
                name="serviceInterval"
                onChange={handleIntervalDropdown}
                options={service}
                renderOwnOption={(options: string[] | Option[]) => {
                    const newOptions = options as Option[];
                    return (
                        <>
                            <option value="">
                                {
                                    fieldsLabel?.selectYourServiceIntervalPlaceHolderText
                                }
                            </option>
                            {newOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </>
                    );
                }}
                placeholder={
                    fieldsLabel?.selectYourServiceIntervalPlaceHolderText
                }
                ariaLabel={
                    fieldsLabel?.selectYourServiceIntervalPlaceHolderText ??
                    'Please Select Your Service Interval'
                }
                disabled={disabled}
            />
        </div>
    );
};

export default ServiceIntervalDropdown;
